import { render, staticRenderFns } from "./mineDiscount.vue?vue&type=template&id=c1c056ba&scoped=true&"
import script from "./mineDiscount.vue?vue&type=script&lang=js&"
export * from "./mineDiscount.vue?vue&type=script&lang=js&"
import style0 from "./mineDiscount.vue?vue&type=style&index=0&id=c1c056ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c056ba",
  null
  
)

export default component.exports